export default "__VITE_ASSET__BLqKFeQZ__"